export default {
  data () {
    return {
      rules: {
        required: (value) => !!value || 'This field is required',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail'
        },
        emailRequired: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Valid e-mail is required'
        },
        int: (value) => {
          const pattern = /^\d+$/
          return pattern.test(value) || 'Must be number (no decimals)'
        },
        posInt: (value) => {
          const pattern = /^[1-9]{1}\d*$/
          return pattern.test(value) || 'Must be a positive number (no decimals)'
        },
        intOrEmpty: (value) => {
          const pattern = /^\d+|null|^\s*$/
          return pattern.test(value) || 'Must be number (no decimals) or empty'
        },
        decimal: (value) => {
          const pattern = /^-?(?=.?\d)\d*(\.\d{0,2})?$/
          return pattern.test(value) || 'Must be number, max 2 decimals'
        },
        decimalOrEmpty: (value) => {
          const pattern = /(^-?(0|([1-9][0-9]*))(\.[0-9]{1,2})?$)|(^(0{0,1}|([1-9][0-9]*))(\.[0-9]{1,2})?$)|null$/
          // the above may be preferable since the pattern below can fail in various ways (still testing this - MJ)

          // const pattern = /^-?(?=.?\d)\d*(\.\d{0,2})?|null$/
          // const pattern = /^-?(?=.?\d)\d*(\.\d{0,2})?|null|^\s*$/
          // the above pattern will pass "11a" and "1.111" but the api call will fail with either - MJ
          return pattern.test(value) || 'Must be number, max 2 decimals'
        },
        min8long: (value) => {
          const pattern = /^.*(?=.{8,}).*$/
          return pattern.test(value) || 'Must be at least 8 characters long'
        },
        containLetter: (value) => {
          const pattern = /^.*(?=.*[a-zA-Z]).*$/
          return pattern.test(value) || 'Must contain a letter'
        },
        containNumber: (value) => {
          const pattern = /^.*(?=.*\d).*$/
          return pattern.test(value) || 'Must contain a number'
        },
        usernameSpec: (value) => {
          const pattern = /^[a-z0-9]{6,}$/
          return pattern.test(value) || 'Min length 6, lowercase letters and numbers only'
        },
        phoneNumber: (value) => {
          // const pattern = /^\d{10}$/
          // return  !value || pattern.test(value) || 'Must be 10 digits (only numbers)'
          const pattern = /^([0-9]{3})[-]{1}([0-9]{3})[-]{1}([0-9]{4})$|^(?![\s\S])/
          return  !value || pattern.test(value) || 'xxx-xxx-xxxx (or empty)'
        },
        postalCode: (value) => {
          // this addition of " |^(?![\s\S]) " allows for an empty string in the input
          const pattern = /^(?:[A-Z]\d[A-Z][ ]\d[A-Z]\d)$|^(?![\s\S])/
          return  !value || pattern.test(value) || 'format must be A1A 1A1 (or empty)'
        }
      }
    }
  }
}
